import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

export const InfoBanner = ({ children }) => {
    const [isOpen, setOpen] = useState(true);

    if (!isOpen) {
        return null;
    }

    return (
        <Grid item xs={12} className="banner info">
            <IconButton
                className="bannerCloseButton"
                aria-label="Close banner"
                size="small"
                onClick={() => setOpen(false)}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
            {children}
        </Grid>
    );
};
